import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { Link } from '@router/Link';

import useCashGiftRecommended from './hooks/useCashGiftRecommended';
import styles from './styles.module.scss';

function PrepaidCard() {
  const data = useCashGiftRecommended();
  return (
      <Column fullWidth
              align='center'
              className={styles.container}>
          <Row spacing={12} className={styles.cardList}
               fullWidth>
              {data?.items.map((item) => {
                const { name, itemId, thumbnailUrl } = item;
                return (
                      <Link activityParams={{ type: 'GIFT', giftItemId: itemId }}
                            activityName='PrepaidCardImagesActivity'>
                          <Column key={itemId}
                                  spacing={8}
                                  align='center'
                                  className={styles.cardContainer}>
                              <Image className={styles.card}
                                     src={thumbnailUrl} />
                              <Text color={colors.gray6}>{name}</Text>
                          </Column>
                      </Link>
                );
              })}
          </Row>
          {data?.title && (
              <Text size='xl' fontWeight='bold' color={colors.gray7}>
                  {data.title}
              </Text>
          )}
      </Column>
  );
}

export default PrepaidCard;
